module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Thunder-21d17c29c15e0739f31cbaf9fa57fb8d.svg";